var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("search-page", {
        directives: [
          {
            name: "hasPermi",
            rawName: "v-hasPermi",
            value: ["platform:feedback:list"],
            expression: "['platform:feedback:list']",
          },
        ],
        ref: "searchPage",
        attrs: {
          "form-data": _vm.formData,
          columns: _vm.columns,
          formatter: _vm.formatter,
          request: _vm.getList,
        },
        scopedSlots: _vm._u([
          {
            key: "table-imageUrls",
            fn: function (ref) {
              var row = ref.row
              return [
                row.imageUrls && row.imageUrls.length > 0
                  ? _vm._l(row.imageUrls, function (src) {
                      return _c("el-image", {
                        key: src,
                        staticClass: "mr8",
                        attrs: { src: src, "preview-src-list": row.imageUrls },
                      })
                    })
                  : [_vm._v("-")],
              ]
            },
          },
          {
            key: "table-append",
            fn: function () {
              return [
                _c("el-table-column", {
                  attrs: {
                    fixed: "right",
                    label: "操作",
                    align: "center",
                    "min-width": "220",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          row.status === 0
                            ? _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.markHandle(row)
                                    },
                                  },
                                },
                                [_vm._v("标记处理")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }